import NavBar from "./components/NavBar.component";
import Footer from "./components/Footer.component";
import CustomScrollbar from "./components/CustomScrollbar.component";
import FakeNewsSection from "./components/StandForIndia/FakeNewsSection.component";

function FakeNews() {
    return (
        <section className="">
            {/* NAVIGATION BAR */}
            <section className="">
                <NavBar />
            </section>

            {/* NAV-CONTACT */}
            <section>{/* <NavContact /> */}</section>

            {/* Fake News */}
            <section>
                <FakeNewsSection />
            </section>

            {/* FOOTER */}
            <section>
                <Footer />
            </section>

            <CustomScrollbar />
        </section>
    );
}

export default FakeNews;

